import { Button, Modal } from "antd";
import React from "react";

const AudioPlayer = ({ link }) => {
  const [open, setOpen] = React.useState(false);
  return (
    <div>
      <Button type="primary" onClick={() => setOpen(true)}>
        Play
      </Button>

      <Modal
        open={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
        width={800}
        footer={null}
      >
        <audio controls className="w-full">
          <source src={link} type="audio/mpeg" />
        </audio>
      </Modal>
    </div>
  );
};

export default AudioPlayer;
